import { render, staticRenderFns } from "./BuyCardYingyou.vue?vue&type=template&id=ebfcd09a&scoped=true&"
import script from "./BuyCardYingyou.vue?vue&type=script&lang=js&"
export * from "./BuyCardYingyou.vue?vue&type=script&lang=js&"
import style0 from "./BuyCardYingyou.vue?vue&type=style&index=0&id=ebfcd09a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfcd09a",
  null
  
)

export default component.exports